import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CustomEmojiListResponse } from '@cyphex/types/admin';
import { emojiApi } from '../api/emojiApi';
import { EMOJI_KEYS } from '../api/queryKeys';

const EMPTY: CustomEmojiListResponse = {
  emoji: [],
  quota: { used: 0, limit: 0 },
  canCreate: false,
};

/**
 * The tenant's custom emoji.
 *
 * Cached for five minutes and shared by every picker on the page: the set
 * changes a handful of times a month, and re-fetching it each time a popover
 * opens would be one request per emoji reaction.
 */
export function useCustomEmoji(enabled = true): UseQueryResult<CustomEmojiListResponse> {
  return useQuery({
    queryKey: EMOJI_KEYS.list(),
    queryFn: () => emojiApi.list(),
    enabled,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    placeholderData: EMPTY,
  });
}
